import { useEffect, useState } from 'react'
import { QuoteForm } from '../components/QuoteForm'
import { getSources } from '../lib/api'
import type { Source } from '../lib/api'

export const NewQuote = () => {
  const [sources, setSources] = useState<Source[]>([])

  useEffect(() => {
    getSources().then((res) => setSources(res.data)).catch(() => {})
  }, [])

  return <QuoteForm sources={sources} />
}
